const extractResponseMessage = (responseBody) => {
    if (!responseBody) {
        return null;
    }

    if (typeof responseBody === "string") {
        return responseBody;
    }

    return responseBody.Message || responseBody.message || responseBody.error || responseBody.detail || null;
};

export const extractValidationErrors = (responseBody) => {
    if (!responseBody || typeof responseBody !== "object") {
        return null;
    }

    const raw = responseBody.errors ?? responseBody.Errors;
    if (!raw || typeof raw !== "object") {
        return null;
    }

    const out = {};
    for (const [key, val] of Object.entries(raw)) {
        if (Array.isArray(val)) {
            out[key] = val.map(String);
        } else if (typeof val === "string") {
            out[key] = [val];
        }
    }

    return Object.keys(out).length ? out : null;
};

const readResponseBody = async (response) => {
    if (response.status === 204) {
        return null;
    }

    const contentType = response.headers.get("content-type") || "";
    if (contentType.includes("application/json")) {
        return response.json();
    }

    const bodyText = await response.text();
    return bodyText || null;
};

/**
 * Requests an initial load for an agency
 * @param {any} initialLoadRequest The initial load request
 * @param {function} callBackResponse The callback invoked with { status, message, data }
 */
export function initialLoad(initialLoadRequest, callBackResponse) {
    fetch("api/InitialLoad/RequestInitialLoad", {
        method: "post",
        headers: {
            "Accept": "application/json",
            "Content-Type": "application/json"
        },
        body: JSON.stringify(initialLoadRequest)
    })
        .then(async (response) => {
            const responseBody = await readResponseBody(response);

            callBackResponse({
                status: response.status,
                message: extractResponseMessage(responseBody),
                data: responseBody
            });
        })
        .catch(() => {
            callBackResponse({
                status: 500,
                message: "An unexpected error occurred while processing the Initial Load request. Please try again later."
            });
        });
}
